import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_CALCULATOR_COMMUNITIES ({ commit }) {
    const query = `query gemeinden {
      gemeinden {
        id
        name
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      commit('SET_CALCULATOR_COMMUNITIES', data.data.gemeinden)
    }

    return data
  },
  async GET_APPLICATION_COMMUNITIES ({ commit }) {
    const query = `query gemeinden {
      gemeinden {
        id
        name
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      commit('SET_APPLICATION_COMMUNITIES', data.data.gemeinden)
    }

    return data
  },
  async GET_COMMUNITY_INFO ({ state, commit }, communityId) {
    const query = `query gemeindeMeta($input: GemeindeInput!) {
      gemeindeMeta: gemeindeMeta(input: $input) {
        ...metaInfo
      }

      kantonMeta: gemeindeMeta(input: { gemeindeId: 86 }) {
        ...metaInfo
      }

      bundMeta: gemeindeMeta(input: { gemeindeId: 87 }) {
        ...metaInfo
      }
    }

    fragment metaInfo on GemeindeMeta {
      id
      name
      infoBlocks{
        text
        type
        url
      }
    }`

    const variables = {
      input: {
        gemeindeId: communityId
      }
    }

    const { data } = await gql({ query, variables })

    return data
  }
}
